import { enableProdMode, importProvidersFrom, Injector } from "@angular/core";
import { environment } from '../../src/environments/environment';
import { createCustomElement } from '@angular/elements';
import { BrowserModule, createApplication } from "@angular/platform-browser";
import { MaterialModule } from "../../src/app/shared/material/material.module";
import { TranslateLoader, TranslateModule } from "@ngx-translate/core";
import { HttpClient, provideHttpClient, withInterceptorsFromDi } from "@angular/common/http";
import { HttpLoaderFactory } from "../../src/app/app.module";
import { TreatmentLocatorComponent } from "../../src/app/treatment-locator/treatment-locator.component";
import { BrowserAnimationsModule } from "@angular/platform-browser/animations";

if (environment.production) {
  enableProdMode();
}

createApplication({
  providers: [
    importProvidersFrom(
      BrowserModule,
      BrowserAnimationsModule,
      MaterialModule,
      TranslateModule.forRoot({
        defaultLanguage: 'en',
        loader: {
          provide: TranslateLoader,
          useFactory: HttpLoaderFactory,
          deps: [HttpClient]
        }
      }), // PreventionModule
    ),
    provideHttpClient(withInterceptorsFromDi()),
  ]
})
  .then((app) => {
    const element = createCustomElement(TreatmentLocatorComponent, { injector: app.injector })
    customElements.define('treatment-locator', element)
  })
  .catch((err) => console.error(err))
